import { api } from '../services/api';
import { setFlashMessage } from './flashMessage';
import { 
  FETCH_PRIVILEGIOS_REQUEST,
  FETCH_PRIVILEGIOS_SUCCESS,
  FETCH_PRIVILEGIOS_FAILURE,
  FETCH_PRIVILEGIOS_USUARIO_REQUEST,
  FETCH_PRIVILEGIOS_USUARIO_SUCCESS,
  FETCH_PRIVILEGIOS_USUARIO_FAILURE,
  CREATE_PRIVILEGIO_REQUEST,
  CREATE_PRIVILEGIO_SUCCESS,
  CREATE_PRIVILEGIO_FAILURE,
  UPDATE_PRIVILEGIO_REQUEST,
  UPDATE_PRIVILEGIO_SUCCESS,
  UPDATE_PRIVILEGIO_FAILURE,
  DELETE_PRIVILEGIO_REQUEST,
  DELETE_PRIVILEGIO_SUCCESS,
  DELETE_PRIVILEGIO_FAILURE,
  OTORGAR_PRIVILEGIOS_MASIVOS_REQUEST,
  OTORGAR_PRIVILEGIOS_MASIVOS_SUCCESS,
  OTORGAR_PRIVILEGIOS_MASIVOS_FAILURE,
  FETCH_RESUMEN_PRIVILEGIOS_REQUEST,
  FETCH_RESUMEN_PRIVILEGIOS_SUCCESS,
  FETCH_RESUMEN_PRIVILEGIOS_FAILURE,
  VERIFICAR_PRIVILEGIO_REQUEST,
  VERIFICAR_PRIVILEGIO_SUCCESS,
  VERIFICAR_PRIVILEGIO_FAILURE,
  LIMPIAR_PRIVILEGIOS_STATE
} from './types';

// Obtener privilegios con filtros
export const fetchPrivilegios = (perPage = 20, offSet = 0, filtros = {}) => async (dispatch) => {
  dispatch({ type: FETCH_PRIVILEGIOS_REQUEST });
  
  try {
    const params = new URLSearchParams({
      perPage: perPage.toString(),
      offSet: offSet.toString(),
      ...filtros
    });
    
    const response = await api.get(`/privilegios?${params}`);
    
    dispatch({
      type: FETCH_PRIVILEGIOS_SUCCESS,
      payload: response.data
    });
    
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Error al obtener privilegios';
    dispatch({
      type: FETCH_PRIVILEGIOS_FAILURE,
      payload: errorMessage
    });
    dispatch(setFlashMessage(errorMessage, 'error'));
    throw error;
  }
};

// Obtener privilegios de un usuario específico
export const fetchPrivilegiosUsuario = (usuarioId) => async (dispatch) => {
  dispatch({ type: FETCH_PRIVILEGIOS_USUARIO_REQUEST });
  
  try {
    const response = await api.get(`/privilegios/usuario/${usuarioId}`);
    
    dispatch({
      type: FETCH_PRIVILEGIOS_USUARIO_SUCCESS,
      payload: response.data
    });
    
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Error al obtener privilegios del usuario';
    dispatch({
      type: FETCH_PRIVILEGIOS_USUARIO_FAILURE,
      payload: errorMessage
    });
    dispatch(setFlashMessage(errorMessage, 'error'));
    throw error;
  }
};

// Crear nuevo privilegio
export const createPrivilegio = (privilegioData, callback) => async (dispatch) => {
  dispatch({ type: CREATE_PRIVILEGIO_REQUEST });
  
  try {
    const response = await api.post('/privilegios', privilegioData);
    
    dispatch({
      type: CREATE_PRIVILEGIO_SUCCESS,
      payload: response.data
    });
    
    dispatch(setFlashMessage('Privilegio creado exitosamente', 'success'));
    
    if (callback) callback();
    
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Error al crear privilegio';
    dispatch({
      type: CREATE_PRIVILEGIO_FAILURE,
      payload: errorMessage
    });
    dispatch(setFlashMessage(errorMessage, 'error'));
    throw error;
  }
};

// Actualizar privilegio
export const updatePrivilegio = (privilegioId, privilegioData, callback) => async (dispatch) => {
  dispatch({ type: UPDATE_PRIVILEGIO_REQUEST });
  
  try {
    const response = await api.patch(`/privilegios/${privilegioId}`, privilegioData);
    
    dispatch({
      type: UPDATE_PRIVILEGIO_SUCCESS,
      payload: response.data
    });
    
    dispatch(setFlashMessage('Privilegio actualizado exitosamente', 'success'));
    
    if (callback) callback();
    
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Error al actualizar privilegio';
    dispatch({
      type: UPDATE_PRIVILEGIO_FAILURE,
      payload: errorMessage
    });
    dispatch(setFlashMessage(errorMessage, 'error'));
    throw error;
  }
};

// Eliminar privilegio
export const deletePrivilegio = (privilegioId, callback) => async (dispatch) => {
  dispatch({ type: DELETE_PRIVILEGIO_REQUEST });
  
  try {
    const response = await api.delete(`/privilegios/${privilegioId}`);
    
    dispatch({
      type: DELETE_PRIVILEGIO_SUCCESS,
      payload: privilegioId
    });
    
    dispatch(setFlashMessage('Privilegio eliminado exitosamente', 'success'));
    
    if (callback) callback();
    
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Error al eliminar privilegio';
    dispatch({
      type: DELETE_PRIVILEGIO_FAILURE,
      payload: errorMessage
    });
    dispatch(setFlashMessage(errorMessage, 'error'));
    throw error;
  }
};

// Otorgar privilegios masivos
export const otorgarPrivilegiosMasivos = (privilegiosData, callback) => async (dispatch) => {
  dispatch({ type: OTORGAR_PRIVILEGIOS_MASIVOS_REQUEST });
  
  try {
    const response = await api.post('/privilegios/masivos', privilegiosData);
    
    dispatch({
      type: OTORGAR_PRIVILEGIOS_MASIVOS_SUCCESS,
      payload: response.data
    });
    
    dispatch(setFlashMessage(`Privilegios otorgados a ${response.data.exitosos} usuarios`, 'success'));
    
    if (callback) callback();
    
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Error al otorgar privilegios masivos';
    dispatch({
      type: OTORGAR_PRIVILEGIOS_MASIVOS_FAILURE,
      payload: errorMessage
    });
    dispatch(setFlashMessage(errorMessage, 'error'));
    throw error;
  }
};

// Obtener resumen de privilegios
export const fetchResumenPrivilegios = () => async (dispatch) => {
  dispatch({ type: FETCH_RESUMEN_PRIVILEGIOS_REQUEST });
  
  try {
    const response = await api.get('/privilegios/resumen');
    
    dispatch({
      type: FETCH_RESUMEN_PRIVILEGIOS_SUCCESS,
      payload: response.data
    });
    
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Error al obtener resumen de privilegios';
    dispatch({
      type: FETCH_RESUMEN_PRIVILEGIOS_FAILURE,
      payload: errorMessage
    });
    dispatch(setFlashMessage(errorMessage, 'error'));
    throw error;
  }
};

// Verificar privilegio específico
export const verificarPrivilegio = (usuarioId, modulo, accion) => async (dispatch) => {
  dispatch({ type: VERIFICAR_PRIVILEGIO_REQUEST });
  
  try {
    const response = await api.get('/privilegios/verificar', {
      params: { usuarioId, modulo, accion }
    });
    
    dispatch({
      type: VERIFICAR_PRIVILEGIO_SUCCESS,
      payload: response.data
    });
    
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Error al verificar privilegio';
    dispatch({
      type: VERIFICAR_PRIVILEGIO_FAILURE,
      payload: errorMessage
    });
    throw error;
  }
};

// Limpiar cache de privilegios
export const limpiarCachePrivilegios = () => async (dispatch) => {
  try {
    const response = await api.delete('/privilegios/cache/limpiar');
    dispatch(setFlashMessage('Cache de privilegios limpiado', 'success'));
    return response;
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Error al limpiar cache';
    dispatch(setFlashMessage(errorMessage, 'error'));
    throw error;
  }
};

// Limpiar estado de privilegios
export const limpiarPrivilegiosState = () => ({
  type: LIMPIAR_PRIVILEGIOS_STATE
});
